const KEY_VALUE = 'KeyValue';
const PRODUCT_LIST_SOURCE = 'productListSource';

function getComponentIdentity(component, predicateType = PRODUCT_LIST_SOURCE) {
    const predicatesMap = {
        [PRODUCT_LIST_SOURCE]: data => data.type === KEY_VALUE && data.key === PRODUCT_LIST_SOURCE
    };

    try {
        const identityFragments = [];
        const handlerType = component?.features?.[0]?.handlerType;
        const featuresData = component?.featuresData;
        const predicate = predicatesMap[predicateType];
        const source = featuresData?.find(predicate);

        if (handlerType) {
            identityFragments.push(handlerType);

            if (predicate && source?.value) {
                identityFragments.push(source.value);
            }
        }

        if (!identityFragments.length) {
            throw new Error(`No handlerType found for ${component.type}. Use SID "${component.sid}" instead.`);
        }

        const identity = identityFragments.join('_');

        return identity;
    } catch (error) {
        Sephora.logger.info(error?.message);

        return component.sid;
    }
}

export default { getComponentIdentity };
